import React, { useState } from "react";
import CallComponent from "./CallComponent";

const ParentPage = () => {
  const [phoneNumber, setPhoneNumber] = useState("+886912235475");
  const [callStatus, setCallStatus] = useState("");
  const [mqttStatus, setMqttStatus] = useState("");

  return (
    <div className="container mt-5">
      <h2> 通話管理系統</h2>
      <label>輸入電話號碼:</label>
      <input 
        type="tel" 
        className="form-control" 
        value={phoneNumber} 
        onChange={(e) => setPhoneNumber(e.target.value)} 
      />

      {/* ✅ 傳入 Twilio 通話狀態 & MQTT 狀態的 Callback */}
      <CallComponent 
        phoneNumber={phoneNumber} 
        onCallStatusChange={setCallStatus} 
        onMqttMessage={setMqttStatus} 
      />

      {/* 📡 MQTT 訊息顯示 */}
      <div className="alert alert-primary mt-3">
        <strong> MQTT 訊息:</strong> {mqttStatus}
      </div>

      {/* 📞 Twilio 訊息顯示 */}
      <div className="alert alert-warning mt-3">
        <strong>通話狀態:</strong> {callStatus}
      </div>
    </div>
  );
};

export default ParentPage;
